import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../store/activeTabSlice";
import { cn } from "../../common/u1/cn";
import { MenuIcon } from "../../../assets/ui/icons";

/* The phone bottom bar. Transcribed from the design export's injected `.tabbar` (adaptive.js): four routes plus a Menu button that opens the same drawer the... */
export const TAB_ITEMS = [
  { name: "Dashboard", label: "Home" },
  { name: "My Businesses", label: "Business" },
  { name: "Following", label: "Following" },
  { name: "Purchased", label: "Purchased" },
];

export const resolveTabs = (links = [], wanted = TAB_ITEMS) =>
  wanted
    .map(({ name, label }) => {
      const item = links.find((l) => l.name === name);
      return item ? { ...item, label } : null;
    })
    .filter(Boolean);

const TAB =
  "relative flex flex-col items-center justify-center gap-[3px] " +
  "text-[10.5px] font-semibold tracking-[-.01em] font-sans";

/* The active tab's cap, drawn on the bar's top edge. */
const CAP =
  "before:absolute before:inset-x-[28%] before:top-0 before:h-[2.5px] " +
  "before:rounded-b-[3px] before:bg-[var(--coral)] before:content-['']";

export const MobileTabBar = ({ links = [], onOpenNav = () => {}, className = "" }) => {
  const dispatch = useDispatch();
  const tabs = resolveTabs(links);

  if (tabs.length === 0) return null;

  return (
    <nav
      aria-label="Main"
      className={cn(
        /* Phones only — the rail is the navigation from 744px up. Fixed so it
           stays put while the page scrolls, and above the sheets' scrim ground
           but below the sheets themselves. */
        "fixed inset-x-0 bottom-0 z-[200] hidden border-t border-[var(--line)]",
        "bg-white/95 backdrop-blur-[12px] max-[743px]:block",
        /* Clear of the home indicator on a notched phone. */
        "pb-[env(safe-area-inset-bottom,0px)]",
        className
      )}
    >
      <div className="grid h-[58px] grid-cols-5">
        {tabs.map(({ name, link, label, Icon }) => (
          <NavLink
            key={name}
            to={link}
            end={link === "/dashboard"}
            /* Transcribed from the rail: following an item records it as the
               active section, which is what the top bar shows as the heading. */
            onClick={() => dispatch(setActiveTab(name))}
            className={({ isActive }) =>
              cn(TAB, isActive ? `text-[var(--coral)] ${CAP}` : "text-[var(--muted)]")
            }
          >
            {Icon && <Icon className="h-[21px] w-[21px] shrink-0" aria-hidden="true" />}
            <span className="max-w-full truncate">{label}</span>
          </NavLink>
        ))}

        {/* Everything the four tabs leave out. Opens the rail's own drawer, so
            there is one navigation on a phone, not two. */}
        <button
          type="button"
          onClick={onOpenNav}
          aria-label="Open navigation"
          className={cn(TAB, "text-[var(--muted)]")}
        >
          <MenuIcon className="h-[21px] w-[21px] shrink-0" />
          <span className="max-w-full truncate">Menu</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileTabBar;
